module.exports = __webpack_public_path__ + "static/media/element-logo.8966d731.png";